export default __webpack_public_path__ + "static/media/480_dummy2016-fotograf03-mobile-de.17840a4e.png";